var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3713_37602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 22.4609V46.4845H46.4844V22.4609",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0234 14.4531H0.976562V22.2656H49.0234V14.4531Z",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2892 14.3885C20.7798 13.6138 20.4727 12.7266 20.4727 11.8742C20.4727 9.61367 22.0953 8.35742 25.0007 8.35742C27.906 8.35742 29.5287 9.61367 29.5287 11.8742C29.5287 12.7266 29.2216 13.6138 28.7122 14.3885",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8176 10.0917C14.6029 4.74569 4.85382 -0.928037 3.66876 8.8163C3.31651 11.7131 4.14112 13.4147 5.63419 14.3893",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5369 14.0256C19.0544 13.0794 15.1455 11.0437 11.6133 10.1348",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1758 10.0975C35.3901 4.74986 45.1459 -0.931587 46.3313 8.81626C46.6836 11.713 45.859 13.4147 44.3659 14.3893",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4648 14.0256C30.9474 13.0794 34.8562 11.0437 38.3885 10.1348",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6289 15.1641V21.7772",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3711 15.1641V21.7772",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.582 45.9959V22.7539",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.418 45.9959V22.7539",
    stroke: "#26C3C0",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3713_37602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift1);
export default __webpack_public_path__ + "static/media/gift 1.0afb9d2ecaf88329adea06b92bdff45c.svg";
export { ForwardRef as ReactComponent };